export const DASHBOARD_CHART_SERIES = [
  { dataKey: "managementCompanies" as const, label: "Gestoras", color: "#2A78D6" },
  { dataKey: "clients" as const, label: "Clientes", color: "#008300" },
] as const;
